import {gutHubComDomain} from './useOutsideRepository.consts'

export function getMatchHosts(hosts: Set<string>, link?: string) {
  if (link) {
    try {
      const url = link.startsWith('http') ? link : `https://${link}`
      const {host} = new URL(url)

      return hosts.has(host)
    } catch (e) {
      return false
    }
  }

  return false
}

export function getHttpsRepositoryUrlFromSsh(value: string) {
  const gitHubSshKey = 'git@github.com:'
  const isSshUrlDetected = value && value.startsWith(gitHubSshKey) && value.endsWith('.git')

  if (isSshUrlDetected) {
    try {
      const urlPath = value.replace(gitHubSshKey, '')
      const domain = `https://${gutHubComDomain}`
      const url = new URL(urlPath, domain)

      return url.href
    } catch (e) {
      return value
    }
  }
  return value
}

export const getRepositoryDetailsItemFromUrl = (link: string) => {
  try {
    const url = link.startsWith('http') ? link : `https://${link}`
    const {pathname} = new URL(url)
    const [, login, repositoryUrl] = pathname.split('/')
    const repositoryName = repositoryUrl.replace('.git', '')

    return {
      login,
      repositoryName,
    }
  } catch (e) {
    return undefined
  }
}
